export default __webpack_public_path__ + "static/media/underbelly.df184374.png";